<script>
import Profile from "@/components/_Shared/Professionals/Profile";
import Biography from "@/components/_Shared/Professionals/Biography/Index";

export default {
  props: {
    professional: {
      type: Object,
      required: true
    }
  },
  components: {
    Profile,
    Biography
  }
};
</script>

<template>
  <section>
    <profile :account="professional.account" />
    <biography v-if="professional.account.profile.bio" :account="professional.account" />
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Feedbacks/Professional.vue